import api from "./api";

class PedidoAPI {

    async getPedidosCompra(headers, params) {
        const response = await api.get("/get_pedidos_compra", {params, headers});
        return response;
    }

    async getItensPedido(headers, params) {
        const response = await api.get("/get_itens_pedido", {params, headers});
        return response;
    }

    async getGruposFornecedores(headers) {
        const response = await api.get("/get_grupos_fornecedores_pedido", {headers});
        return response;
    }

    async getFornecedores(headers) {
      const response = await api.get("/get_fornecedores_pedido", {headers});
      return response;
  }

    async reabrirPedidoCompra(headers, params) {
        const response = await api.get("/reabrir_pedido_compra", {headers, params});
        return response;
    }

    async getCompradoresPedidos(headers) {
        const response = await api.get("/get_compradores_pedidos", {headers});
        return response;
    }

    async getEventos(headers,params) {
        const response = await api.get("/get_eventos", {headers,params});
        return response;
    }

    async getTiposEvento(headers) {
        const response = await api.get("/get_tipos_evento", {headers});
        return response;
    }

    async cadastrarEvento(headers, params) {
        const response = await api({
            method: 'post',
            url: '/cadastrar_evento',
            headers,
            data: params
        });
        return response;
    }

    async addProdutoEvento(headers, params) {
        const response = await api({
            method: 'post',
            url: '/add_produto_evento',
            headers,
            data: params
        });
        return response;
    }

    async getProdutosEvento(headers, params) {
        const response = await api.get("/get_produtos_evento", {headers, params});
        return response;
    }

    async getItensEvento(headers,params) {
        const response = await api.get("/get_itens_vento", {headers,params});
        return response;
    }

    async excluirProdutoEvento(headers, params) {
        const response = await api({
            method: 'delete',
            url: '/excluir_produto_evento',
            headers,
            data: params
        });
        return response;
    }

    async setTipoEvento(headers, params) {
        const response = await api({
            method: 'post',
            url: '/set_tipo_evento',
            headers,
            data: params
        });
        return response;
    }

    async deleteTipoEvento(headers, params) {
        const response = await api({
            method: 'delete',
            url: '/delete_tipo_evento',
            headers,
            data: params
        });
        return response;
    }

    async cancelarCotacao(headers, params) {
        const response = await api({
            method: 'delete',
            url: '/cancelar_cotacao',
            headers,
            data: params
        });
        return response;
    }


}

export default new PedidoAPI();
